module.exports = __webpack_public_path__ + "img/plus-primary.d457d78a.svg";